import { render, staticRenderFns } from "./ChoiceBill.vue?vue&type=template&id=99d5ed50"
import script from "./ChoiceBill.vue?vue&type=script&lang=js"
export * from "./ChoiceBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports